import { Injectable } from '@angular/core';
import { TuiAlertService } from '@taiga-ui/core';
import { take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

const ERROR_HEADING = 'system.alert.error';
const WARNING_HEADING = 'system.alert.warning';
const INFO_HEADING = 'system.alert.info';
const SUCCESS_HEADING = 'system.alert.success';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(
    private readonly alertService: TuiAlertService,
    private readonly transloco: TranslocoService,
  ) {}

  showError(message: string = '') {
    this.alertService
      .open(message, {
        label: this.transloco.translate(ERROR_HEADING),
        status: 'error',
        autoClose: true,
      })
      .pipe(take(1))
      .subscribe();
  }

  showSuccess(message: string = '') {
    this.alertService
      .open(message, {
        label: this.transloco.translate(SUCCESS_HEADING),
        status: 'success',
        autoClose: true,
      })
      .pipe(take(1))
      .subscribe();
  }

  showWarning(message: string = '') {
    this.alertService
      .open(message, {
        label: this.transloco.translate(WARNING_HEADING),
        status: 'warning',
        autoClose: true,
      })
      .pipe(take(1))
      .subscribe();
  }

  showInfo(message: string = '') {
    this.alertService
      .open(message, {
        label: this.transloco.translate(INFO_HEADING),
        status: 'info',
        autoClose: true,
      })
      .pipe(take(1))
      .subscribe();
  }
}
